import { render } from "./sidentify.vue?vue&type=template&id=f4f07d9c&scoped=true"
import script from "./sidentify.vue?vue&type=script&lang=js"
export * from "./sidentify.vue?vue&type=script&lang=js"

import "./sidentify.vue?vue&type=style&index=0&id=f4f07d9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4f07d9c"

export default script